import React from 'react';
import {Carousel } from 'react-bootstrap'
import axios from "axios";
import configData from "../../config/config.json";

class LoginPageSlides extends React.Component {

	state = {
		numberOfSlides: 0,
		altText: {
			"one": null,
			"two": null,
			"three": null,
			"four": null,
			"five": null,
			"six": null
		}
	}

	fetchAltText() {
		fetch(configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/slideAltText.json")
			.then((res) => res.text())
			.then((text) => {
				const altText = JSON.parse(text);
				this.setState({
					altText
				});
			})
			.catch((e) => console.error(e));
	}

	componentDidMount() {
		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "auth/loginPageSlides", { withCredentials: true })
			.then(
				(response) => {
					this.setState({
						numberOfSlides: response.data.content.numberOfSlides
					}, this.fetchAltText()
				);
				},
				(error) => {
					//   handleError(error, this.props.history);
				}
			);
	}

	render() {
		const slide1 = configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/one.jpg";
		const slide2 = configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/two.jpg";
		const slide3 = configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/three.jpg";
		const slide4 = configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/four.jpg";
		const slide5 = configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/five.jpg";
		const slide6 = configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/six.jpg";	
		let text1 = this.state.altText.one? this.state.altText.one : '';
		let text2 = this.state.altText.two? this.state.altText.two : '';
		let text3 = this.state.altText.three? this.state.altText.three : '';
		let text4 = this.state.altText.four? this.state.altText.four : '';
		let text5 = this.state.altText.five? this.state.altText.five : '';
		let text6 = this.state.altText.six? this.state.altText.six : '';

		if (!this.state.numberOfSlides || this.state.numberOfSlides <= 1) {
			return (
				<Carousel style={{ boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }} autoPlay={false} controls={false} indicators={false} >
					{
						this.state.numberOfSlides === 1 &&
						<Carousel.Item>
							<div class="image-container">
  								<img border="0" src={slide1} className="img-fluid" />
							</div>
							
						</Carousel.Item>
					}
				</Carousel>
			)
		}

		let interval = 30000;

		return (
			
			<>
				<Carousel style={{ boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }} autoPlay={true} controls={true} indicators={true} interval={interval} >
					{
						this.state.numberOfSlides >= 1 &&
						<Carousel.Item>
							<div class="image-container">
  								<img border="0" src={slide1} alt={text1} class="img-fluid" />								
							</div>
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 2 &&
						<Carousel.Item>
							<img border="0" src={slide2} alt={text2} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 3 &&
						<Carousel.Item>
							<img border="0" src={slide3} alt={text3} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 4 &&
						<Carousel.Item>
							<img border="0" src={slide4} alt={text4} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 5 &&
						<Carousel.Item>
							<img border="0" src={slide5} alt={text5} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 6 &&
						<Carousel.Item>
							<img border="0" src={slide6} alt={text6} class="img-fluid" />
						</Carousel.Item>
					}
				</Carousel>
			</>
		)
	}
}

export default LoginPageSlides;